module.exports = ".select-area select.roundInput {\n  margin-bottom: 15px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/select-area/select-area.component.css
// module id = ./src/app/admin/components/select-area/select-area.component.css
// module chunks = main